// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\InviteUsers\InviteUsersViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { Role, RoleData, RoleOptions } from 'data/models/Role';

// InviteUsersResponseData is the class that InviteUsersResponse serializes to/from
export interface InviteUsersResponseData {
	
    AssignableRoles : RoleData[] | null;
    AvailableOrganizations : OrganizationData[] | null;
	
    CanManageOrgs : boolean;
}

// InviteUsersResponseOptions is the class which may be passed to the InviteUsersResponse constructor to define optional initial data values
export interface InviteUsersResponseOptions {
	
    AssignableRoles? : RoleOptions[] | null;
    AvailableOrganizations? : OrganizationOptions[] | null;
	
    CanManageOrgs? : boolean;
}

export class InviteUsersResponse {
	
    public AssignableRoles : SDataArray<Role>;
    public AvailableOrganizations : SDataArray<Organization>;
	
    public CanManageOrgs : DataSignal<boolean>;

    constructor();
    constructor(data : InviteUsersResponseOptions);
    constructor(data: InviteUsersResponseOptions | null = null) {
	    
        this.AssignableRoles = SArray<Role>([]);
        this.AvailableOrganizations = SArray<Organization>([]);
	    
        this.CanManageOrgs = jsonableObservable(S.value<boolean>(data && data.CanManageOrgs !== undefined ? data.CanManageOrgs : false));
    }

    static key(obj : InviteUsersResponse) {
        return ;
    }
    
    static dataKey(obj : InviteUsersResponseOptions) {
        return ;
    }

    static update(obj : InviteUsersResponse, data : InviteUsersResponseOptions) {
        S.freeze(() => {
	        
	        
            if (data.CanManageOrgs !== undefined) obj.CanManageOrgs(data.CanManageOrgs);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/InviteUsersResponse.ts